export enum FilterNameEnum {
    SERVICE = 'SERVICE',
    LOCATION = 'LOCATION',
    DATE = 'DATE',
    DATE_RANGE = 'DATE_RANGE',
    CONTRACTOR = 'CONTRACTOR',
    SUBCONTRACTOR = 'SUBCONTRACTOR',
}
